import styled from 'styled-components'
import Button from 'ui/src/components/controls/button'
import IconButton from 'ui/src/components/controls/icon-button'

export const Menu = styled.ul`
    margin: 0;
    padding: 10px 5px;
`

export const MenuItem = styled.li`
    display: flex;
    margin: 0;
    width: 100%;

    &:active {
        opacity: 0.8;
    }
`

export const MenuItemLabel = styled(Button)`
    text-align: left;
    width: 100%;

    &:active {
        opacity: 1;
    }
`

export const MenuItemIcon = styled(IconButton)`
    flex-shrink: 0;

    &:active {
        opacity: 1;
    }
`
